import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export const IconMenuNav = styled.nav.withConfig({
  displayName: "IconMenuNav",
  componentId: "sc-1a5dps4-0"
})(["position:absolute;z-index:100;top:36px;right:0;visibility:hidden;opacity:0;width:248px;padding:6px 0;", ";text-align:left;transform:translateY(-6px);"], getFont(0, 'xcompact'));
export const IconMenuNavInner = styled.div.withConfig({
  displayName: "IconMenuNav__IconMenuNavInner",
  componentId: "sc-1a5dps4-1"
})(["overflow:hidden;padding:6px 0 0;border-radius:", ";box-shadow:", ";background:#fff;"], _ref => {
  let {
    theme
  } = _ref;
  return theme.borderRadius;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.boxShadow;
});